import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider, useAuth } from "@/admin/AuthContext";
import { ApartmentDataProvider } from "@/data/ApartmentDataContext";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import BuildingPage from "@/pages/BuildingPage";
import ApartmentDetail from "@/pages/ApartmentDetail";
import Location from "@/pages/Location";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";

import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";

const ProtectedRoute = ({ children }) => {
  const { admin, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen bg-charcoal flex items-center justify-center">
        <span className="text-gold/60 text-sm uppercase tracking-widest">...</span>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <ApartmentDataProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/projektas" element={<About />} />
                <Route path="/migdolas" element={<BuildingPage buildingKey="Migdolas" route="migdolas" />} />
                <Route path="/migdolas/:unit" element={<ApartmentDetail buildingKey="Migdolas" route="migdolas" />} />
                <Route path="/vysnia" element={<BuildingPage buildingKey="Vyšnia" route="vysnia" />} />
                <Route path="/vysnia/:unit" element={<ApartmentDetail buildingKey="Vyšnia" route="vysnia" />} />
                <Route path="/vieta" element={<Location />} />
                <Route path="/galerija" element={<Gallery />} />
                <Route path="/kontaktai" element={<Contact />} />
              </Route>

              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/crm" element={<Navigate to="/admin" replace />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          </ApartmentDataProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
